// POC1
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { DestructiveConfirmButton, ConfirmButton as DefaultConfirmButton, CancelButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import s from './ConfirmationModal.scss';
const ConfirmButton = (_param)=>{
    var { confirmBtnType, // Destructuring children here to get around a lint issue
    children } = _param, rest = _object_without_properties(_param, [
        "confirmBtnType",
        "children"
    ]);
    switch(confirmBtnType){
        case 'danger':
            return /*#__PURE__*/ React.createElement(DestructiveConfirmButton, rest, children);
        case 'core':
            return /*#__PURE__*/ React.createElement(DefaultConfirmButton, _object_spread({
                variant: "core-orange"
            }, rest), children);
        case 'dark':
        case 'default':
        default:
            return /*#__PURE__*/ React.createElement(DefaultConfirmButton, rest, children);
    }
};
const ConfirmationModal = ({ isOpen = false, title, text, icon, variant, withCancelButton = true, cancelBtnLabel, cancelBtnBiData, confirmBtnLabel, confirmBtnType = 'default', confirmBtnDisabled = false, confirmBtnBiData, onCancel, onConfirm, onRequestClose, doNotShowAgainKey, onDoNotShowAgainChange, autoAcceptForDoNotShow, useTransparentOverlay })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const doNotShowHandler = useCallback((value)=>{
        if (!doNotShowAgainKey) {
            return;
        }
        onDoNotShowAgainChange && onDoNotShowAgainChange(doNotShowAgainKey, value);
    }, [
        doNotShowAgainKey,
        onDoNotShowAgainChange
    ]);
    const handleConfirm = useCallback(()=>{
        yieldToMain(()=>{
            onConfirm && onConfirm();
        });
    }, [
        onConfirm
    ]);
    const handleCancel = useCallback(()=>{
        yieldToMain(()=>{
            onCancel && onCancel();
        });
    }, [
        onCancel
    ]);
    const handleRequestClose = useCallback((e)=>{
        yieldToMain(()=>{
            const cb = onRequestClose || onCancel || onConfirm;
            cb && cb(e);
        });
    }, [
        onRequestClose,
        onCancel,
        onConfirm
    ]);
    useEffect(()=>{
        if (onConfirm && isOpen && autoAcceptForDoNotShow === true) {
            onConfirm();
        }
    }, [
        isOpen,
        autoAcceptForDoNotShow,
        onConfirm
    ]);
    if (autoAcceptForDoNotShow) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(MessageModal, {
        isOpen: isOpen,
        title: title,
        message: text,
        className: s['root'],
        contentClassName: s['content'],
        variant: variant || isMobile ? 'vertical' : 'horizontal',
        image: icon,
        useTransparentOverlay: useTransparentOverlay,
        footerButtons: [
            withCancelButton && /*#__PURE__*/ React.createElement(CancelButton, {
                key: "cancel",
                onClick: handleCancel,
                biData: cancelBtnBiData
            }, cancelBtnLabel !== null && cancelBtnLabel !== void 0 ? cancelBtnLabel : t('popup.cancel')),
            /*#__PURE__*/ React.createElement(ConfirmButton, {
                key: "confirm",
                confirmBtnType: confirmBtnType,
                disabled: confirmBtnDisabled,
                onClick: handleConfirm,
                biData: confirmBtnBiData
            }, confirmBtnLabel)
        ],
        onRequestClose: handleRequestClose,
        doNotShowAgainText: t('popup.doNotShowAgain'),
        onDoNotShowAgainChange: doNotShowAgainKey ? doNotShowHandler : undefined
    });
};
ConfirmationModal.displayName = 'ConfirmationModal';
export default ConfirmationModal;
